import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { python_countries } from 'src/environments/environments';


@Injectable({
  providedIn: 'root'
})
export class GeolocalizationService {

  private readonly ApiGeoUrl: string = `${python_countries.url_base}${python_countries.api}`;


  constructor(
    private http: HttpClient,
  ) { }

  getCountries(): Observable<any> {
    return this.http.get<any>(`${this.ApiGeoUrl}/paises`);
  }

  getStates(countryId: number): Observable<any> {
    const url = `${this.ApiGeoUrl}/departamentos?country_id=${countryId}`;
    return this.http.get<any>(url);
  }

  getCities(stateId: number): Observable<any> {
    const url = `${this.ApiGeoUrl}/ciudades?state_id=${stateId}`;
    return this.http.get<any>(url);
  }
}
